import styled from 'styled-components/macro';
import { colour, fontSize, lineHeight } from '@notonthehighstreet/toolkit/utils';

const typeStyles = type => {
  if (type === 'error') {
    return {
      color: '#ff6174',
      backgroundColor: '#f5e0e2',
    };
  }
  if (type === 'success') {
    return {
      display: 'flex',
      alignItems: 'center',
      color: '#0c948b',
      backgroundColor: '#bdeae8',
    };
  }
  if (type === 'container') {
    return {
      border: `1px solid ${colour('timberwolf')}`,
      margin: '0',
    };
  }
  if (type === 'underPanelError') {
    return {
      border: `1px solid ${colour('chestnut-rose')}`,
      borderBottomRightRadius: '0px',
      borderBottomLeftRadius: '0px',
      borderBottom: 'none',
      margin: '0',
    };
  }
  if (type === 'information') {
    return {
      backgroundColor: '#e2f1f5',
      color: '#056c96',
    };
  }

  return {};
};

export const Container = styled.div(
  {
    borderRadius: '3px',
    fontSize: fontSize('s'),
    lineHeight: lineHeight('m'),
    padding: '16px',
    margin: '16px 0',
  },
  ({ type }) => typeStyles(type)
);
